/**
 * Modal drill-down: epic → child task/bug keeps {@link epicParentId} so Save on the child
 * returns to the epic in the same overlay; Save on the epic (or a top-level item) closes it.
 */

export function navigateWorkItemDetailModal(prev, relatedId, { fromEpicChild = false } = {}) {
  if (!prev || relatedId == null || String(relatedId).trim() === "") return prev;
  const related = String(relatedId).trim();
  const currentId = String(prev.issueId ?? "").trim();
  const epicParentId = prev.epicParentId ? String(prev.epicParentId) : null;

  if (epicParentId && related === epicParentId) {
    return { ...prev, issueId: related, epicParentId: null };
  }
  if (fromEpicChild && currentId && related !== currentId) {
    return { ...prev, issueId: related, epicParentId: currentId };
  }
  return { ...prev, issueId: related };
}

/** After save: return updated modal state, or null to close the overlay. */
export function getWorkItemDetailModalStateAfterSave(modalState) {
  const epicParentId = modalState?.epicParentId ? String(modalState.epicParentId) : null;
  if (!epicParentId) return null;
  return { ...modalState, issueId: epicParentId, epicParentId: null };
}
